import React, {Fragment, useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import Loader from "../../components/shared/Loader/Loader";
import UsersApi from "../../services/Users.api";

const UserComponent = () => {
  const {userId} = useParams();
  const navigate = useNavigate();
  const [loading, SetLoading] = useState(true);
  const [login, SetLogin] = useState("");
  const [deviceIdToLink, SetDeviceIdToLink] = useState("");
  const [devices, SetDevices] = useState([]);

  useEffect(() => {
    const getDeviceInfoAsync = async () => {
      const userResponse = await UsersApi.getUser(String(userId));

      if (!userResponse) {
        return;
      }

      SetLoading(false);
      SetLogin(userResponse.login);
      SetDevices(userResponse.devices ?? []);
    };

    getDeviceInfoAsync();
  }, [userId]);

  const seedData = async () => {
    const userResponse = await UsersApi.getUser(String(userId));

    if (!userResponse) {
      return;
    }

    SetLoading(false);
    SetDevices(userResponse.devices ?? []);
  };

  const linkDevice = async (userId, deviceId) => {
    try {
      await UsersApi.linkDevice(String(userId), String(deviceId));
      await seedData()
    } catch {
    }
  };

  const unlinkDevice = async (userId, deviceId) => {
    try {
      await UsersApi.unlinkDevice(String(userId), String(deviceId));
      await seedData()
    } catch {
    }
  };

  const render = () => {
    return (
      <Fragment>
        <div className="mb-3">
          <button className="btn btn-link" onClick={() => navigate("/users", {replace: true})}>К списку пользователей
          </button>
        </div>
        {
          loading
            ? <Loader/>
            : content()
        }
      </Fragment>
    )
  }

  const content = () => {
    return (
      <Fragment>
        <h1>{login}</h1>
        <h3>Устройства</h3>
        <table className="table">
          <thead>
          <tr>
            <td>Устройство</td>
            <td>Серийный номер</td>
            <td>Серийный номер ЧС</td>
            <td>Действия</td>
          </tr>
          </thead>
          <tbody>
          {
            devices.map((device, id) => (
              <tr key={device.id}>
                <td><Link to={`/devices/${device.id}`}>
                  {device.id}
                </Link>
                </td>
                <td>
                  {device.serialNumber}
                </td>
                <td>
                  {device.clockSerialNumber}
                </td>
                <td>
                  <button className={"btn btn-danger"}
                          onClick={async () => {
                            await unlinkDevice(userId, device.id)
                          }}>
                    Удалить
                  </button>
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
        <div className={"row"}>
          <div className={"col"}>
            <div className={"input-group"}>
              <div className="input-group-text">
                <label className="form-label">ID</label>
              </div>
              <input className={"form-control"}
                     value={deviceIdToLink}
                     onChange={(event) => {
                       event.preventDefault();
                       SetDeviceIdToLink(event.target.value)
                     }}
              />
              <button className={"btn btn-primary"}
                      onClick={async () => {
                        await linkDevice(userId, deviceIdToLink)
                      }}>Добавить
              </button>

            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  return render();
};

export default UserComponent;
